export function initItemPresentation(){
   const listPlaceholderElement=document.querySelector(".js-product-list-placeholder");
   const listDataInput=document.querySelector(".js-product-list-data");
    if(listPlaceholderElement && listDataInput){
        const items = JSON.parse(listDataInput.value);
        items.forEach(item => {
            const li = document.createElement('li');
            li.textContent = `${item.item_no} ${item.description}`;
            listPlaceholderElement.appendChild(li);
        });
    }
}
